import React from 'react'
import { Route,Routes,HashRouter  } from 'react-router-dom';
import './App.css';
import Login  from './pages/Login';
import CheckEmail  from './pages/CheckEmail';
import Personalize  from './pages/Personalize';
import Personalizeend  from './pages/Personalizeend';
import Personalizeauthor  from './pages/Personalizeauthor';
import Personalizesection  from './pages/Personalizesection';
import Register  from './pages/Register';
import UpdateName  from './pages/UpdateName';
import Personalizenewsletter  from './pages/Personalizenewsletter';
import Mypage  from './pages/Mypage';
import MyNewsleter  from './pages/MyNewsleter';
import EditProfile  from './pages/EditProfile';
import ResetPassword  from './pages/ResetPassword';
import ChangePassword  from './pages/ChangePassword';
import Frontpage  from './pages/Frontpage';
import MyBookmarks  from './pages/MyBookmarks';
import MyFavoriteTags  from './pages/MyFavoriteTags';




import PasswordAndConfirmPasswordValidation  from './PasswordAndConfirmPasswordValidation';



function App() {
const handleChecknow = (evnt) => {
  if (evnt === 'success') {
  }

}
const [html] = document.getElementsByTagName("html")
const lang = html.getAttribute("lang");


  return (
    <HashRouter hashType='noslash'>
       <Routes forceRefresh={true}>
       <Route  path="/frontpage" element={ <Frontpage lang={lang} />} />
          <Route  path="/" element={ <CheckEmail lang={lang}/>} />
          <Route  path="/MyBookmarks" element={ <MyBookmarks lang={lang} />} />
          <Route  path="/mypage" element={ <Mypage lang={lang}/>} />
          <Route  path="/MyFavoriteTags/:section" element={ <MyFavoriteTags lang={lang}/>} />
          <Route  path="/MyFavoriteTags" element={ <MyFavoriteTags lang={lang}/>} />
          <Route  path="/forget_password" element={ <ResetPassword lang={lang}/>} />
          <Route  path="/forget_password/:email" element={ <ResetPassword lang={lang}/>} />
          <Route  path="/change_password" element={ <ChangePassword lang={lang} />} />
          <Route  path="/my_newsletter" element={ <MyNewsleter lang={lang}/>} />
          <Route  path="/editprofile" element={ <EditProfile lang={lang} />} />
          <Route  path="registersimple/:email" element={ <PasswordAndConfirmPasswordValidation lang={lang}/>} />
          <Route  path="UpdateName" element={ <UpdateName  fetchownusercallback={handleChecknow} lang={lang} />} />
          <Route  path="login/:email" element={ <Login lang={lang}/>} />
          <Route  path="register" element={ <Register lang={lang}/>} />
          <Route  path="personalize" element={ <Personalize lang={lang}/>} />
          <Route  path="personalize-author" element={ <Personalizeauthor lang={lang}/>} />
          <Route  path="personalize-sections" element={ <Personalizesection lang={lang}/>} />
          <Route  path="personalize-newsletter" element={ <Personalizenewsletter lang={lang}/>} />
          <Route  path="personalize-end" element={ <Personalizeend lang={lang}/>} />
          <Route   path="*" element={ <CheckEmail lang={lang}/>} />
        </Routes>
    </HashRouter>
  );
}

export default App;
